module.exports = __webpack_public_path__ + "assets/PTM55F_W.90312b2fd840124a8b32019f9641738bdb1a3a020958ad5cb96f1c8ceb9e29bb.woff";